<template>
  <transition name="fade">
    <div class="sidebar-QRcode">
      <div class="title f-db" target="_blank" v-if="companyMsg">
        <img @click="goCom" :src="companyMsg.logo" class="empty-img" v-if="companyMsg.logo" />
        <img @click="goCom" src="@assets/img/empty.png" class="empty-img" v-else />
        <p v-if="companyMsg.nameEn" :title="companyMsg.nameEn">{{ companyMsg.nameEn }}</p>
        <p v-else :title="companyMsg.name">{{ companyMsg.name }}</p>
      </div>

      <template v-if="joinInfo && joinInfo.tempInfo">
        <div class="joinInfo" v-for="(item, index) in joinInfo.tempInfo" :key="'theme' + index"
          v-if="item.type === 2 && item.isOpen">
          <div class="theme">
            <span>seek cooperation</span>
            <img src="@assets/img/joinInfo-title.png" />
          </div>
          <div class="category" v-for="(item, index) in joinInfo.tempInfo" :key="index">
            <template v-if="item.type === 2 && item.isOpen && item.content.length">
              <div style="display: flex;" v-for="(itm, idx) in item.content" :key="idx">
                <span v-if="itm.typeId === 5">Product category：</span>
                <div style="flex:1;display:flex;flex-wrap:wrap;" v-if="itm.typeId === 5 && itm.value && itm.value.length">
                  <p v-for="(im, ix) in itm.value" :key="ix">{{ im }}</p>
                </div>
              </div>
            </template>
          </div>
          <div class="category region" v-for="(item, index) in joinInfo.tempInfo" :key="'region' + index">
            <template v-if="item.type === 2 && item.isOpen && item.content.length">
              <div style="display: flex;" v-for="(itm, idx) in item.content" :key="'region' + idx">
                <span v-if="itm.typeId === 6">Sales region：</span>
                <div style="flex:1;display:flex;flex-wrap:wrap;" v-if="itm.typeId === 6 && itm.value && itm.value.length">
                  <p v-for="(im, ix) in itm.value" :key="'region' + ix">{{ im }}</p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
      <div class="code" v-if="url">
        <!-- <div id="qrcode2" class="qrcode"></div> -->
        <img :src="url" />
        <p>More information is on WeChat mini program</p>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import QRCode from "qrcodejs2";

export default {
  name: "sidebar-QRcode",
  props: ["url", "showCom", 'companyMsg', 'joinInfo'],
  data() {
    return {
      myqrcode2: null,
      compId: ""
    };
  },
  computed: {
    ...mapGetters({
      exhibitionId: 'getExhibitionId'
    }),
  },
  mounted() {
    // this.qrcode(this.url);
    // this.compId = this.$router.history.current.query.compId;
  },
  methods: {
    // qrcode(url) {
    //   this.myqrcode2 = new QRCode("qrcode2", {
    //     width: 200,
    //     height: 200, // 高度
    //     text: url // 二维码内容
    //   });
    // },
    goCom() {
      // this.$router.push(`/ex-details/${this.companyMsg.joinId}?compId=${this.companyMsg.compId}`);
      const url = `${location.origin}/ex-details/${this.companyMsg.joinId}?compId=${this.companyMsg.compId}`;
      window.open(url, "_blank");
    }
  }
};
</script>

<style scoped lang='scss'>
@import "@assets/scss/utils.scss";

.sidebar-QRcode {
  width: 300px;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
  border-radius: 2px;
  background-color: #fff;
  margin-bottom: 20px;
  text-align: center;
  position: relative;
  @include empty-txt(300px, "暂无信息");

  .title {
    min-height: 215px;
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 10px;
  }

  .title img {
    width: 96px;
    height: 96px;
    margin-top: 40px;
    border: solid 1px #e6e6e6;
    border-radius: 5px;
    border-radius: 50%;
    cursor: pointer;
  }

  .title p {
    font-size: 18px;
    color: #222;
    margin-top: 20px;
    font-weight: 600;
  }

  .code img {
    margin: 10px auto;
    width: 200px;
    height: 200px;
  }

  .code p {
    font-size: 18px;
    color: #333;
    font-weight: 600;
    padding-bottom: 20px;
  }

  #qrcode2 {
    text-align: center;
    padding: 10px;
  }
}

.joinInfo {
  margin-top: 20px;
  text-align: left;
  padding: 0 20px 20px;
  border-bottom: 1px solid #f5f5f5;

  .theme {
    color: #024c8b;
    font-weight: bold;
    position: relative;
  }

  img {
    position: absolute;
    left: 0;
    bottom: 2px;
  }

  .category {
    margin-top: 10px;

    span {
      color: #666;
    }

    p {
      padding: 2px 8px;
      border: 1px solid #024c8b;
      color: #024c8b;
      border-radius: 4px;
      margin: 0 10px 6px 0;
    }
  }

  .region {
    p {
      background-color: #f2f2f2;
      border: none;
      color: #333;
    }
  }
}
</style>

<style lang='scss'>
.sidebar-QRcode {
  .code img {
    margin: 10px auto !important;
  }
}
</style>